module.exports = JSON.parse("{\"timestamp\":\"20.09.2026 - 16:25:14\",\"brands\":[]}")